export default {"src":"/_next/static/media/itz-greyscale.76138561.svg","height":109,"width":403,"blurWidth":0,"blurHeight":0};